// This file should be pure data.

export const CONSTANTS = {
  "BACKGROUND_GRID_COLS": 16,
  "BACKGROUND_GRID_ROWS": 12,
  "BACKGROUND_TILE_OVERLAP": 1,
  "BACKGROUND_TILE_SIZE": 128,
  "BACKGROUND_TILE_TYPES": [
    "tile1",
    "tile2",
    "tile3",
    "tile4"
  ],
  "BASE_HEALTH": 150,
  "BASE_HIT_DISTANCE": 32,
  "ENEMIES": {
    "basic": {
      "damage": 8,
      "description": "A standard enemy unit. Balanced stats.",
      "health": 25,
      "speed": 1.2,
      "size": 32,
      "shadowRadius": 16,
      "healthBarWidth": 32,
      "fallback": { "radius": 16, "color": "#cc4444" }
    },
    "brute": {
      "damage": 30,
      "description": "A powerful and slow unit that hits very hard.",
      "health": 140,
      "speed": 0.5,
      "size": 44,
      "shadowRadius": 22,
      "healthBarWidth": 44,
      "fallback": { "radius": 22, "color": "#663300" }
    },
    "fast": {
      "damage": 6,
      "description": "Moves quickly but has low health. A swift threat.",
      "health": 15,
      "speed": 2.2,
      "size": 32,
      "shadowRadius": 14,
      "healthBarWidth": 32,
      "fallback": { "radius": 14, "color": "#44cccc" }
    },
    "swarm": {
      "damage": 3,
      "description": "A small, very fast enemy that appears in groups. Weak individually.",
      "health": 8,
      "speed": 2.8,
      "size": 20,
      "shadowRadius": 10,
      "healthBarWidth": 20,
      "fallback": { "radius": 10, "color": "#ff66cc" }
    },
    "tank": {
      "damage": 18,
      "description": "Slow-moving but extremely durable with high health.",
      "health": 70,
      "speed": 0.7,
      "size": 40,
      "shadowRadius": 20,
      "healthBarWidth": 40,
      "fallback": { "radius": 20, "color": "#888444" }
    }
  },
  "ENEMIES_PER_WAVE": 2,
  "ENEMY_ANIMATION_BASE_DURATION": 0.6,
  "ENEMY_ANIMATION_BASE_SPEED": 1.2,
  "ENEMY_HEALTH_BAR_BG_COLOR": "#333333",
  "ENEMY_HEALTH_BAR_FG_COLOR": "#de3232",
  "ENEMY_HEALTH_BAR_HEIGHT": 4,
  "ENEMY_HEALTH_BAR_Y_OFFSET": -28,
  "ENEMY_HEALTH_PER_WAVE": 5,
  "ENEMY_SPAWN_INTERVAL": 3,
  "ENEMY_SPAWN_MARGIN": 30,
  "ENEMY_SPAWN_TIME_JITTER": 0.5,
  "ENEMY_SPEED_PER_WAVE": 0.08,
  "ENEMY_SQUASH_SCALE_X": 1.2,
  "ENEMY_SQUASH_SCALE_Y": 0.8,
  "ENEMY_STRETCH_SCALE_X": 0.8,
  "ENEMY_STRETCH_SCALE_Y": 1.2,
  "ENEMY_TYPE_SPAWN_RULES": [
    { "type": "basic", "weight": 40 },
    { "type": "fast", "weight": 18 },
    { "type": "tank", "weight": 12, "minWave": 2 },
    { "type": "swarm", "weight": 20, "minWave": 3 },
    { "type": "brute", "weight": 10, "minWave": 5 }
  ],
  "GAME_BACKGROUND_COLOR": "#222222",
  "GAME_TITLE": "Tower Defense: Onslaught",
  "INITIAL_MAX_TROOPS": 5,
  "INITIAL_RESOURCES": 120,
  "LOCAL_STORAGE_HIGH_SCORE_KEY": "xenomerge_high_score",
  "LOCAL_STORAGE_MUSIC_VOLUME_KEY": "xenomerge_music_volume",
  "LOCAL_STORAGE_SFX_VOLUME_KEY": "xenomerge_sfx_volume",
  "MAX_DELTA_TIME": 0.05,
  "MAX_ENEMIES_PER_WAVE": 10,
  "MELEE_ATTACK_RANGE": 25,
  "MELEE_ENGAGEMENT_RANGE": 30,
  "MENU_ITEMS": [
    { "id": "start", "label": "Start Game" },
    { "id": "tutorial", "label": "Tutorial" },
    { "id": "settings", "label": "Settings" },
    { "id": "credits", "label": "Credits" }
  ],
  "MERGE_COMBINATIONS": {
    "apex_predator": ["sniper_melee", "soldier_melee"],
    "assassin": ["champion_warrior", "sniper_melee"],
    "assassin_vanguard": ["sniper_melee", "vanguard"],
    "battle_ranger": ["ranger", "soldier_melee"],
    "berserker": ["champion_warrior", "elite_scout"],
    "champion": ["champion_warrior", "vanguard"],
    "champion_warrior": ["melee", "melee"],
    "combat_marksman": ["soldier_melee", "soldier_sniper"],
    "commander": ["champion_warrior", "soldier_sniper"],
    "crusader": ["champion_warrior", "ranger"],
    "death_stalker": ["master_sniper", "phantom"],
    "deathdealer": ["soldier_sniper", "master_sniper"],
    "elite_marksman": ["master_sniper", "vanguard"],
    "elite_scout": ["scout", "scout"],
    "elite_soldier": ["soldier_melee", "vanguard"],
    "ghost": ["phantom", "ranger"],
    "ghost_sniper": ["master_sniper", "master_sniper"],
    "guardian": ["champion_warrior", "heavy_soldier"],
    "heavy_soldier": ["soldier", "soldier"],
    "hybrid_commander": ["sniper_melee", "soldier_sniper"],
    "infiltrator": ["elite_scout", "sniper_melee"],
    "juggernaut": ["champion_warrior", "phantom"],
    "lord_of_war": ["champion_warrior", "champion_warrior"],
    "marksman_elite": ["master_sniper", "ranger"],
    "master_sniper": ["sniper", "sniper"],
    "melee": ["melee", "melee"],
    "phantom": ["scout", "sniper"],
    "phantom_soldier": ["phantom", "soldier_melee"],
    "phantom_vanguard": ["phantom", "vanguard"],
    "precision_killer": ["master_sniper", "sniper_melee"],
    "ranger": ["scout", "melee"],
    "ranger_assassin": ["ranger", "sniper_melee"],
    "ranger_leader": ["ranger", "vanguard"],
    "ranger_marksman": ["ranger", "soldier_sniper"],
    "recon_specialist": ["elite_scout", "soldier_melee"],
    "scout_commander": ["elite_scout", "vanguard"],
    "shadow_assassin": ["phantom", "sniper_melee"],
    "shadow_hunter": ["elite_scout", "master_sniper"],
    "sniper_commander": ["master_sniper", "soldier_melee"],
    "sniper_melee": ["sniper", "melee"],
    "soldier_melee": ["soldier", "melee"],
    "soldier_sniper": ["soldier", "sniper"],
    "spectral_commander": ["phantom", "soldier_sniper"],
    "spectre": ["elite_scout", "elite_scout"],
    "stalker": ["elite_scout", "ranger"],
    "tactical_assassin_elite": ["sniper_melee", "soldier_melee"],
    "vanguard": ["scout", "soldier"],
    "vanguard_sniper": ["soldier_sniper", "vanguard"],
    "war_machine": ["heavy_soldier", "heavy_soldier"],
    "warlord": ["champion_warrior", "master_sniper"],
    "wraith": ["elite_scout", "phantom"]
  },
  "MUSIC_VOLUME": 0.3,
  "PAUSED_MUSIC_VOLUME": 0.1,
  "PARTICLE_EFFECT": {
    "COLORS": ["#FFFFFF", "#F5F5DC", "#D3D3D3", "#A9A9A9", "#F0F0F0", "#E5E5E5"],
    "FRICTION": 0.98,
    "MAX_LIFESPAN": 1,
    "MAX_RADIUS": 4,
    "MAX_SPEED": 300,
    "MIN_LIFESPAN": 1.5,
    "MIN_RADIUS": 3,
    "MIN_SPEED": 100,
    "PARTICLE_COUNT": 50,
    "SIZE_DECAY_RATE": 0.7
  },
  "PROJECTILE_HIT_RADIUS": 16,
  "RESOURCE_PER_KILL": 15,
  "RESOURCE_PER_TICK": 10,
  "RESOURCE_TICK": 1,
  "SCREEN_SHAKE": {
    "DURATION": 0.5,
    "FREQUENCY": 20,
    "INTENSITY": 8
  },
  "SFX_VOLUME": 0.6,
  "SFX_VOLUME_MULTIPLIERS": {
    "mergeTroop": 1.2,
    "attackRanged": 0.7,
    "attackMelee": 0.8,
    "enemyHit": 0.5,
    "enemyDie": 0.9,
    "baseHit": 1.5
  },
  "SHADOW_COLOR": "#000000",
  "SHADOW_OFFSET_Y": 8,
  "SHADOW_OPACITY": 0.3,
  "SHADOW_SCALE_X": 0.8,
  "SHADOW_SCALE_Y": 0.3,
  "TITLE_LOGO_MAX_WIDTH": "40%",
  "SPLASH": {
    "text": "made with",
    "backgroundColor": "#1A1A1A",
    "textColor": "#E5E5E5",
    "imageCategory": "sprites",
    "imageKey": "splash_logo",
    "imageDisplayWidth": 192,
    "imageDisplayHeight": 192,
    "popScaleFrom": 0.8,
    "popOvershoot": 1.08,
    "popScaleTo": 1.0,
    "popDurationMs": 700,
    "gridColor": "#404040",
    "gridDotSize": 1,
    "gridSpacing": 20,
    "fadeOutDelayMs": 3200,
    "fadeOutDurationMs": 800,
    "fadeOutScaleTo": 0.8
  },
  "TROOPS": {
    "apex_predator": { "attackCooldown": 1, "cost": 0, "damage": 100, "description": "A fearsome hybrid predator, combining the skills of an assassin and a combat specialist.", "health": 250, "name": "Apex Predator", "projectileSpeed": 12, "range": 220, "speed": 2, "type": "hybrid" },
    "assassin": { "attackCooldown": 0.7, "cost": 0, "damage": 110, "description": "A master of stealth and precision, striking from the shadows.", "health": 160, "name": "Assassin", "projectileSpeed": 13, "range": 180, "speed": 2.5, "type": "hybrid" },
    "assassin_vanguard": { "attackCooldown": 0.8, "cost": 0, "damage": 100, "description": "A vanguard assassin who leads stealth operations from the front.", "health": 170, "name": "Assassin Vanguard", "projectileSpeed": 11, "range": 180, "speed": 2.5, "type": "hybrid" },
    "battle_ranger": { "attackCooldown": 0.6, "cost": 0, "damage": 80, "description": "A combat-hardened ranger who excels in both ranged and melee combat.", "health": 180, "name": "Battle Ranger", "projectileSpeed": 9, "range": 150, "speed": 2.5, "type": "hybrid" },
    "berserker": { "attackCooldown": 0.4, "cost": 0, "damage": 85, "description": "A frenzied warrior with incredible speed and devastating melee attacks.", "health": 200, "name": "Berserker", "projectileSpeed": 0, "range": 125, "speed": 3.5, "type": "melee" },
    "champion": { "attackCooldown": 0.7, "cost": 0, "damage": 75, "description": "The ultimate warrior, combining strength, speed, and tactical prowess.", "health": 240, "name": "Champion", "projectileSpeed": 9, "range": 150, "speed": 2.2, "type": "hybrid" },
    "champion_warrior": { "attackCooldown": 0.5, "cost": 0, "damage": 60, "description": "A powerful warrior created by merging two basic Warriors. Deals high damage.", "health": 150, "name": "Champion Warrior", "projectileSpeed": 0, "range": 130, "speed": 2.2, "type": "melee" },
    "combat_marksman": { "attackCooldown": 0.8, "cost": 0, "damage": 95, "description": "A versatile combatant equally skilled with rifle and blade.", "health": 170, "name": "Combat Marksman", "projectileSpeed": 12, "range": 200, "speed": 1.5, "type": "hybrid" },
    "commander": { "attackCooldown": 0.8, "cost": 0, "damage": 85, "description": "A tactical genius who leads from the front lines.", "health": 200, "name": "Commander", "projectileSpeed": 11, "range": 190, "speed": 1.5, "type": "hybrid" },
    "crusader": { "attackCooldown": 0.6, "cost": 0, "damage": 70, "description": "A holy warrior dedicated to protecting allies and destroying evil.", "health": 280, "name": "Crusader", "projectileSpeed": 0, "range": 135, "speed": 2.8, "type": "melee" },
    "death_stalker": { "attackCooldown": 1.4, "cost": 0, "damage": 115, "description": "A phantom sniper that delivers death from impossible distances.", "health": 95, "name": "Death Stalker", "projectileSpeed": 13, "range": 240, "speed": 1.2, "type": "hybrid" },
    "deathdealer": { "attackCooldown": 1.5, "cost": 0, "damage": 150, "description": "The pinnacle of ranged power, created from the best marksmen.", "health": 100, "name": "Deathdealer", "projectileSpeed": 15, "range": 300, "speed": 0, "type": "ranged" },
    "elite_marksman": { "attackCooldown": 1.1, "cost": 0, "damage": 90, "description": "A versatile marksman with superior training and equipment.", "health": 115, "name": "Elite Marksman", "projectileSpeed": 10, "range": 220, "speed": 2, "type": "hybrid" },
    "elite_scout": { "attackCooldown": 0.6, "cost": 0, "damage": 15, "description": "An upgraded Scout, even faster and more evasive.", "health": 75, "name": "Elite Scout", "projectileSpeed": 0, "range": 120, "speed": 4.5, "type": "melee" },
    "elite_soldier": { "attackCooldown": 0.7, "cost": 0, "damage": 85, "description": "The finest soldier, trained in all forms of combat and tactics.", "health": 190, "name": "Elite Soldier", "projectileSpeed": 10, "range": 160, "speed": 2, "type": "hybrid" },
    "ghost": { "attackCooldown": 0.8, "cost": 0, "damage": 80, "description": "A spectral warrior that moves unseen and strikes without warning.", "health": 130, "name": "Ghost", "projectileSpeed": 11, "range": 170, "speed": 2.8, "type": "hybrid" },
    "ghost_sniper": { "attackCooldown": 1.7, "cost": 0, "damage": 200, "description": "A legendary sniper who can eliminate targets from across the battlefield. The fusion of two masters.", "health": 140, "name": "Ghost Sniper", "projectileSpeed": 15, "range": 350, "speed": 0, "type": "ranged" },
    "guardian": { "attackCooldown": 0.8, "cost": 0, "damage": 80, "description": "The ultimate defensive unit, combining the resilience of a Champion Warrior and a Heavy Soldier.", "health": 400, "name": "Guardian", "projectileSpeed": 9, "range": 150, "speed": 1.2, "type": "hybrid" },
    "heavy_soldier": { "attackCooldown": 0.8, "cost": 0, "damage": 35, "description": "An upgraded Soldier with higher damage and health.", "health": 100, "name": "Heavy Soldier", "projectileSpeed": 7, "range": 120, "speed": 0, "type": "ranged" },
    "hybrid_commander": { "attackCooldown": 0.9, "cost": 0, "damage": 110, "description": "A master tactician who seamlessly blends ranged and melee combat strategies.", "health": 160, "name": "Hybrid Commander", "projectileSpeed": 13, "range": 210, "speed": 1.8, "type": "hybrid" },
    "infiltrator": { "attackCooldown": 0.7, "cost": 0, "damage": 90, "description": "A covert operative skilled in both stealth and combat.", "health": 120, "name": "Infiltrator", "projectileSpeed": 12, "range": 180, "speed": 3.5, "type": "hybrid" },
    "juggernaut": { "attackCooldown": 0.9, "cost": 0, "damage": 75, "description": "An unstoppable force that crushes enemies with overwhelming power.", "health": 220, "name": "Juggernaut", "projectileSpeed": 10, "range": 160, "speed": 2, "type": "hybrid" },
    "lord_of_war": { "attackCooldown": 0.5, "cost": 0, "damage": 130, "description": "The ultimate warrior, born from the fusion of two champions. A true Lord of War.", "health": 350, "name": "Lord of War", "projectileSpeed": 0, "range": 140, "speed": 2.5, "type": "melee" },
    "marksman_elite": { "attackCooldown": 1.1, "cost": 0, "damage": 95, "description": "An elite marksman with exceptional accuracy and mobility.", "health": 140, "name": "Marksman Elite", "projectileSpeed": 12, "range": 230, "speed": 2.5, "type": "hybrid" },
    "master_sniper": { "attackCooldown": 1.8, "cost": 0, "damage": 80, "description": "An upgraded Sniper with superior range and damage.", "health": 60, "name": "Master Sniper", "projectileSpeed": 10, "range": 250, "speed": 0, "type": "ranged" },
    "melee": { "attackCooldown": 0.5, "cost": 40, "damage": 25, "description": "A basic melee unit. Fast and effective in close combat.", "health": 60, "name": "Warrior", "projectileSpeed": 0, "range": 120, "speed": 2.5, "type": "melee" },
    "pathfinder": { "attackCooldown": 0.8, "cost": 0, "damage": 75, "description": "A versatile explorer who excels at both reconnaissance and combat.", "health": 110, "name": "Pathfinder", "projectileSpeed": 11, "range": 200, "speed": 3.2, "type": "hybrid" },
    "phantom": { "attackCooldown": 1.15, "cost": 0, "damage": 50, "description": "A mysterious unit that blends ranged and melee capabilities with high speed.", "health": 65, "name": "Phantom", "projectileSpeed": 11, "range": 180, "speed": 1.5, "type": "hybrid" },
    "phantom_soldier": { "attackCooldown": 0.8, "cost": 0, "damage": 85, "description": "A ghostly soldier that phases between dimensions during combat.", "health": 140, "name": "Phantom Soldier", "projectileSpeed": 10, "range": 180, "speed": 2, "type": "hybrid" },
    "phantom_vanguard": { "attackCooldown": 0.9, "cost": 0, "damage": 75, "description": "A spectral vanguard that leads phantom forces into battle.", "health": 135, "name": "Phantom Vanguard", "projectileSpeed": 9, "range": 160, "speed": 2.2, "type": "hybrid" },
    "precision_killer": { "attackCooldown": 1.2, "cost": 0, "damage": 125, "description": "A master of precision who never misses a critical shot.", "health": 120, "name": "Precision Killer", "projectileSpeed": 14, "range": 250, "speed": 1.8, "type": "hybrid" },
    "ranger": { "attackCooldown": 0.6, "cost": 0, "damage": 35, "description": "A tough melee unit with good speed and damage.", "health": 110, "name": "Ranger", "projectileSpeed": 0, "range": 120, "speed": 3, "type": "melee" },
    "ranger_assassin": { "attackCooldown": 0.7, "cost": 0, "damage": 95, "description": "A wilderness assassin who strikes with the fury of nature.", "health": 150, "name": "Ranger Assassin", "projectileSpeed": 12, "range": 180, "speed": 2.8, "type": "hybrid" },
    "ranger_leader": { "attackCooldown": 0.7, "cost": 0, "damage": 70, "description": "A natural leader who guides ranger units with wisdom and strength.", "health": 170, "name": "Ranger Leader", "projectileSpeed": 9, "range": 160, "speed": 2.8, "type": "hybrid" },
    "ranger_marksman": { "attackCooldown": 0.8, "cost": 0, "damage": 85, "description": "A skilled ranger with exceptional marksmanship abilities.", "health": 160, "name": "Ranger Marksman", "projectileSpeed": 11, "range": 210, "speed": 2.2, "type": "hybrid" },
    "recon_specialist": { "attackCooldown": 0.6, "cost": 0, "damage": 70, "description": "An advanced scout with enhanced combat capabilities.", "health": 130, "name": "Recon Specialist", "projectileSpeed": 10, "range": 160, "speed": 3.8, "type": "hybrid" },
    "scout": { "attackCooldown": 0.8, "cost": 40, "damage": 5, "description": "Very fast melee unit with low health. Good for flanking.", "health": 30, "name": "Scout", "projectileSpeed": 0, "range": 120, "speed": 3, "type": "melee" },
    "scout_commander": { "attackCooldown": 0.7, "cost": 0, "damage": 60, "description": "A leader among scouts, combining speed with tactical awareness.", "health": 125, "name": "Scout Commander", "projectileSpeed": 9, "range": 150, "speed": 3.8, "type": "hybrid" },
    "shadow_assassin": { "attackCooldown": 0.9, "cost": 0, "damage": 105, "description": "An assassin who strikes from the shadows with deadly precision.", "health": 110, "name": "Shadow Assassin", "projectileSpeed": 12, "range": 190, "speed": 2.2, "type": "hybrid" },
    "shadow_hunter": { "attackCooldown": 1.6, "cost": 0, "damage": 120, "description": "A deadly sniper who hunts from the shadows with lethal precision.", "health": 90, "name": "Shadow Hunter", "projectileSpeed": 14, "range": 280, "speed": 0, "type": "ranged" },
    "sniper": { "attackCooldown": 1.5, "cost": 40, "damage": 35, "description": "Long-range specialist. Slow attack speed but high damage.", "health": 25, "name": "Sniper", "projectileSpeed": 10, "range": 180, "speed": 0, "type": "ranged" },
    "sniper_commander": { "attackCooldown": 1.3, "cost": 0, "damage": 105, "description": "A tactical sniper who coordinates long-range operations.", "health": 140, "name": "Sniper Commander", "projectileSpeed": 11, "range": 240, "speed": 1.5, "type": "hybrid" },
    "sniper_melee": { "attackCooldown": 0.8, "cost": 0, "damage": 70, "description": "A deadly assassin that can pick off targets from afar and defend itself in melee.", "health": 100, "name": "Tactical Assassin", "projectileSpeed": 11, "range": 200, "speed": 2, "type": "hybrid" },
    "soldier": { "attackCooldown": 0.7, "cost": 40, "damage": 15, "description": "Basic ranged unit. Reliable and cheap.", "health": 40, "name": "Soldier", "projectileSpeed": 7, "range": 100, "speed": 0, "type": "ranged" },
    "soldier_melee": { "attackCooldown": 0.6, "cost": 0, "damage": 50, "description": "A hybrid unit that can attack from a distance and fight up close.", "health": 120, "name": "Combat Specialist", "projectileSpeed": 8, "range": 140, "speed": 1.8, "type": "hybrid" },
    "soldier_sniper": { "attackCooldown": 0.9, "cost": 0, "damage": 60, "description": "A versatile unit combining the Soldier's rate of fire with the Sniper's range.", "health": 80, "name": "Elite Marksman", "projectileSpeed": 12, "range": 220, "speed": 0, "type": "ranged" },
    "spectral_commander": { "attackCooldown": 1, "cost": 0, "damage": 90, "description": "A phantom leader who commands from beyond the veil of reality.", "health": 125, "name": "Spectral Commander", "projectileSpeed": 11, "range": 200, "speed": 1.8, "type": "hybrid" },
    "spectre": { "attackCooldown": 0.5, "cost": 0, "damage": 40, "description": "So fast it's like a ghost on the battlefield. The result of merging two Elite Scouts.", "health": 180, "name": "Spectre", "projectileSpeed": 0, "range": 130, "speed": 6, "type": "melee" },
    "stalker": { "attackCooldown": 0.5, "cost": 0, "damage": 55, "description": "A relentless hunter that tracks down enemies with unmatched speed.", "health": 140, "name": "Stalker", "projectileSpeed": 0, "range": 125, "speed": 4.2, "type": "melee" },
    "tactical_assassin_elite": { "attackCooldown": 0.8, "cost": 0, "damage": 120, "description": "The pinnacle of tactical assassination, combining stealth with overwhelming firepower.", "health": 180, "name": "Tactical Assassin Elite", "projectileSpeed": 12, "range": 200, "speed": 2.2, "type": "hybrid" },
    "vanguard": { "attackCooldown": 0.75, "cost": 0, "damage": 25, "description": "A durable hybrid unit that leads the charge.", "health": 90, "name": "Vanguard", "projectileSpeed": 8, "range": 120, "speed": 1.5, "type": "hybrid" },
    "vanguard_sniper": { "attackCooldown": 1, "cost": 0, "damage": 90, "description": "A forward sniper who provides overwatch for advancing forces.", "health": 150, "name": "Vanguard Sniper", "projectileSpeed": 12, "range": 230, "speed": 1.8, "type": "hybrid" },
    "war_machine": { "attackCooldown": 0.7, "cost": 0, "damage": 80, "description": "A walking fortress, created by combining two Heavy Soldiers. It unleashes a constant barrage of projectiles.", "health": 250, "name": "War Machine", "projectileSpeed": 9, "range": 150, "speed": 0, "type": "ranged" },
    "warlord": { "attackCooldown": 1.2, "cost": 0, "damage": 95, "description": "A commanding presence on the battlefield, equally deadly at range and in melee.", "health": 180, "name": "Warlord", "projectileSpeed": 12, "range": 200, "speed": 1.8, "type": "hybrid" },
    "wraith": { "attackCooldown": 0.9, "cost": 0, "damage": 65, "description": "A ghostly figure that phases between ranged and melee combat.", "health": 85, "name": "Wraith", "projectileSpeed": 12, "range": 170, "speed": 4, "type": "hybrid" }
  },
  "TROOP_ANIMATION_DURATION": 0.6,
  "TROOP_CLICK_DISTANCE": 20,
  "TROOP_COST_INCREASE_RATE": 1.2,
  "TROOP_HOVER_DISTANCE": 20,
  "TROOP_HOVER_OUTLINE_COLOR": "#ffe066",
  "TROOP_HOVER_OUTLINE_WIDTH": 4,
  "TROOP_LIMIT_UPGRADE_COST_INCREASE_RATE": 1.5,
  "TROOP_LIMIT_UPGRADE_INITIAL_COST": 200,
  "TROOP_MERGE_DISTANCE": 25,
  "TROOP_MOVE_COOLDOWN": 0.2,
  "TROOP_PLACEMENT_RADIUS": 180,
  "TROOP_RETURN_TO_ORIGINAL_POS_THRESHOLD": 5,
  "TROOP_SQUASH_SCALE_X": 1.2,
  "TROOP_SQUASH_SCALE_Y": 0.8,
  "TROOP_STRETCH_SCALE_X": 0.8,
  "TROOP_STRETCH_SCALE_Y": 1.2,
  "TUTORIAL_INITIAL_RESOURCES": 100,
  "TUTORIAL_MAX_TROOPS": 2,
  "TUTORIAL_STEPS": [
    { "hasButton": true, "position": "center", "text": "Your goal is to defend your base in the center from waves of enemies. Let's learn how.", "title": "Welcome to XenoMerge!" },
    { "position": "top-center", "text": "First, you need troops. Click and drag a 'Warrior' from the selection bar below onto the yellow circle.", "title": "Placing Troops" },
    { "hasButton": true, "position": "center", "text": "Your warrior will automatically attack any enemies that come within its range.", "title": "Good Job!" },
    { "position": "top-center", "text": "You can create stronger troops by merging two, discover combinations of troops!. Place another 'Warrior' on the field.", "title": "Merging Troops" },
    { "position": "top-center", "text": "Now, click and drag one of your warriors on top of the other one. They will merge into a more powerful unit!", "title": "Merge Them!" },
    { "hasButton": true, "position": "center", "text": "You've created a Champion Warrior! Merging is key to building a strong defense. Different combinations create different units.", "title": "A New Unit!" },
    { "position": "top-right", "text": "You can learn about troops and enemies in the Codex. Click the book icon in the top-right to open it.", "title": "The Codex" },
    { "position": "top-left-no-arrow", "text": "The Codex shows you stats and merge recipes for units you've discovered. Close it when you're ready.", "title": "Explore and Learn" },
    { "hasButton": true, "position": "center", "text": "That's all you need to know to get started. Good luck, Commander!", "title": "You're Ready!" }
  ],
  "WAVE_ANIMATION_DURATION": 0.6,
  "WAVE_COOLDOWN": 10,
  "WAVE_INTERVAL": 20,
  "ZOOM_INITIAL": 1,
  "ZOOM_MAX": 2,
  "ZOOM_MIN": 1,
  "ZOOM_STEP": 0.1,
  "DRAWING": {
    "BACKGROUND_TILE_FALLBACK_COLORS": {
        "tile1": "#228B22",
        "tile2": "#8B4513",
        "tile3": "#696969",
        "tile4": "#F4A460"
    },
    "PLACEMENT_RADIUS_VALID_COLOR": "rgba(255, 255, 0, 0.5)",
    "PLACEMENT_RADIUS_INVALID_COLOR": "rgba(255, 0, 0, 0.5)",
    "PLACEMENT_RADIUS_LINE_WIDTH": 2,
    "DRAGGING_TROOP_RANGE_STYLE": {
        "strokeStyle": "rgba(255, 230, 102, 0.35)",
        "lineWidth": 3,
        "lineDash": [8, 8],
        "shadowColor": "#ffe066",
        "shadowBlur": 8
    },
    "MERGE_INDICATOR_STYLE": {
        "strokeStyle": "rgba(0, 255, 0, 0.6)",
        "lineWidth": 3,
        "lineDash": [5, 5]
    },
    "BASE_SIZE": 64,
    "BASE_FALLBACK_COLOR": "#8888ff",
    "TROOP_SHADOW_RADIUS": 16,
    "TROOP_SIZE": 32,
    "TROOP_FALLBACK_COLOR": "#44cc44",
    "TROOP_HOVER_RADIUS": 20,
    "TROOP_HOVER_SHADOW_BLUR": 8,
    "PROJECTILE_SIZE": 12,
    "PROJECTILE_FALLBACK_COLOR": "#ffff00",
    "DRAGGING_GHOST_OPACITY": 0.7
  }
};
